import klientkarya from "../../../../assets/klientkarya.png";
import sanetyzer from "../../../../assets/sanetyzer.png";
import mockitup from "../../../../assets/mockitup.png";
import popple from "../../../../assets/popple.png";
import ecommerce from "../../../../assets/ecommerce.png";
import hrm from "../../../../assets/hrm.png";

export const workData = [
  {
    title: "Klientkarya",
    image: klientkarya,
    subTitle: "sub title",
    description: "This is project description.",
    link: "https://google.com",
  },
  {
    title: "Sanetyzer",
    image: sanetyzer,
    subTitle: "sub title",
    description: "This is project description.",
    link: "https://google.com",
  },
  {
    title: "Popple",
    image: popple,
    subTitle: "sub title",
    description: "This is project description.",
    link: "https://google.com",
  },
  {
    title: "Mockup Generator",
    image: mockitup,
    subTitle: "sub title",
    description: "This is project description.",
    link: "https://google.com",
  },

  {
    title: "Ecommerce IRS",
    image: ecommerce,
    subTitle: "sub title",
    description: "This is project description.",
    link: "https://google.com",
  },
  {
    title: "Web based HR Management System",
    image: hrm,
    subTitle: "sub title",
    description: "This is project description.",
    link: "https://google.com",
  },
];
